module.exports = __webpack_public_path__ + "static/media/krystal_maughan.33df7756.jpg";